import styles from './Mark.module.css';

/**
 * Znak platformy — **dwie gwiazdy na skos, bez łączącej kreski** (wariant W2).
 *
 * ⭐ To jedyne miejsce w kodzie, w którym ten rysunek istnieje. Znak stoi nad menu,
 * w kaflu omniboksa, na ekranie logowania i w favikonie (`public/favicon.svg`) — więc
 * gdyby geometria była wpisywana na miejscu, cztery kopie rozjechałyby się przy pierwszej
 * korekcie.
 *
 * ── Skąd ta geometria ────────────────────────────────────────────────────────
 * Wybrana w pięciu turach makiet (`makiety/c3-omnibox-kosmos*.html`,
 * `c3-znak-*.html`), za każdym razem **mierzona, nie oceniana okiem**: znak był
 * rasteryzowany do 16×16 i liczone było pokrycie tuszem. Dwie liczby, które rządzą
 * czytelnością w tej skali:
 *
 * - **promień** — 9 dla głównej, 5,1 dla małej. To sufit: końcówki ramion siedzą
 *   w `c − r`, więc przy środku w (9, 9) promień większy niż 9 **ucina ramię**.
 *   Zwycięzca tury trzeciej (promienie 3–5,4) dawał 12,0% pokrycia; ten daje 23,4%.
 * - **talia ramienia** = `0,19 · r`, czyli punkt kontrolny krzywej. Było 0,14 —
 *   przy 16 px różnica między pół piksela a pikselem, czyli między szarą smugą
 *   a widoczną kreską. Przy 0,24 gwiazda zaczyna wyglądać jak krzyżyk i traci
 *   charakter iskry.
 *
 * ⚠ Ścieżki są **wynikiem generatora**, nie rysowania na oko — dzięki temu gwiazda
 * o promieniu 5,1 ma identycznie smukłe ramiona co ta o promieniu 9. Gdyby trzeba
 * je było przeliczyć, wzór jest w komentarzu przy `favicon.svg`.
 */

const MAIN = 'M9 0Q10.71 7.29 18 9Q10.71 10.71 9 18Q7.29 10.71 0 9Q7.29 7.29 9 0Z';
const COMPANION =
  'M17.5 13.8Q18.47 17.93 22.6 18.9Q18.47 19.87 17.5 24Q16.53 19.87 12.4 18.9Q16.53 17.93 17.5 13.8Z';

/** Sam rysunek, w barwie `currentColor`. Dekoracyjny — nazwę niesie kontekst. */
export function Mark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={MAIN} fill="currentColor" />
      <path d={COMPANION} fill="currentColor" />
    </svg>
  );
}

/**
 * Znak na kaflu — postać, w której marka pokazuje się w interfejsie.
 *
 * Gradient kafla to **jedna rola semantyczna** (`--gradient-mark`), nie trzy wartości
 * wpisane tutaj: kafel jest identyczny w obu motywach, bo to tożsamość, a nie powierzchnia
 * (patrz `semantic.css`, blok ról niezależnych od motywu).
 */
export function MarkTile({ size = 28 }: { size?: number }) {
  return (
    <span className={styles['tile']} style={{ width: size, height: size }}>
      <Mark size={Math.round(size * 0.68)} />
    </span>
  );
}
